import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [persona, setPersonaState] = useState(null);

  const fetchMe = useCallback(async (previewPersona = null) => {
    const params = previewPersona ? { persona: previewPersona } : {};
    const res = await api.get("/auth/me", { params });
    setMe(res.data);
    return res.data;
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      await fetchMe(null);
    } catch (e) {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, [fetchMe]);

  useEffect(() => {
    // CRITICAL: skip /me during OAuth callback; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const setPersona = useCallback(async (p) => {
    setPersonaState(p);
    await fetchMe(p);
  }, [fetchMe]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setMe(null);
    setPersonaState(null);
    window.location.href = "/";
  }, []);

  return (
    <AuthContext.Provider value={{ me, loading, persona, setPersona, fetchMe, logout, refetch: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
